import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { TbCloudUpload } from "react-icons/tb";
import { FaTrash } from "react-icons/fa";
import "./formFive.css";

const FormFive = (props) => {
  const userFive = props.userFive;
  const navigate = useNavigate();

  const [sueldourl, setSueldoUrl] = useState(null);
  const [certificadourl, setCertificadoUrl] = useState(null);
  const [dniurl, setDniUrl] = useState(null);
  const [selfieurl, setSelfieUrl] = useState(null);
  const [sueldoname, setSueldoName] = useState(null);
  const [formError, setFormError] = useState(false);

  const inputRefs = {
    sueldo: useRef(null),
    certificado: useRef(null),
    dni: useRef(null),
    selfie: useRef(null),
    sueldoname: useRef(null),
  };

  const handleFileChange = (event, setFile) => {
    const file = event.target.files[0];
    setFile(file);
  };

  const removeFile = (setFile) => {
    setFile(null);
  };

  const ClickPageSix = () => {
    if (!sueldourl || !certificadourl || !dniurl || !selfieurl || !sueldoname) {
      setFormError(true);
      return;
    }

    const user = {
      UserRegistration: {
        ...userFive.UserRegistration,
        img_user: [sueldourl, certificadourl, dniurl, selfieurl, sueldoname],
      },
    };

    navigate("/Firma", { state: user });
  };
  return (
    <div className="cardform">
      <div className="inputdisplaybox">
        <div className="boxbuttonpersonprev">
          <input
            type="file"
            ref={inputRefs.sueldo}
            onChange={(event) => handleFileChange(event, setSueldoUrl)}
            style={{ display: "none" }}
          />
          <button
            className="boxinputprevarchive"
            onClick={() => inputRefs.sueldo.current.click()}
          >
            <TbCloudUpload className="iconbuttonarchiveprev" />
            <span>Recibo de Sueldo</span>
          </button>
          {sueldourl && (
            <div className="namefiledprov">
              <p className="buttonprevtextarchivedelete">{sueldourl.name}</p>
              <button
                className="buttondeletearchive"
                onClick={() => removeFile(setSueldoUrl)}
              >
                <FaTrash />
              </button>
            </div>
          )}
          {formError && !sueldourl && (
            <p className="errorMesage2">Por favor suba las imágenes pedidas</p>
          )}
        </div>

        <div className="boxbuttonpersonprev">
          <input
            type="file"
            ref={inputRefs.certificado}
            onChange={(event) => handleFileChange(event, setCertificadoUrl)}
            style={{ display: "none" }}
          />
          <button
            className="boxinputprevarchive"
            onClick={() => inputRefs.certificado.current.click()}
          >
            <TbCloudUpload className="iconbuttonarchiveprev" />
            <span>
              Certificado de afectación <br /> de haberes
            </span>
          </button>
          {certificadourl && (
            <div className="namefiledprov">
              <p className="buttonprevtextarchivedelete">
                {certificadourl.name}
              </p>
              <button
                className="buttondeletearchive"
                onClick={() => removeFile(setCertificadoUrl)}
              >
                <FaTrash />
              </button>
            </div>
          )}
          {formError && !certificadourl && (
            <p className="errorMesage2">Por favor suba las imágenes pedidas</p>
          )}
        </div>
      </div>

      <div className="inputdisplaybox">
        <div className="boxbuttonpersonprev">
          <input
            type="file"
            ref={inputRefs.dni}
            onChange={(event) => handleFileChange(event, setDniUrl)}
            style={{ display: "none" }}
          />
          <button
            className="boxinputprevarchive"
            onClick={() => inputRefs.dni.current.click()}
          >
            <TbCloudUpload className="iconbuttonarchiveprev" />
            <span>DNI Frente y Contrafrente</span>
          </button>
          {dniurl && (
            <div className="namefiledprov">
              <p className="buttonprevtextarchivedelete">{dniurl.name}</p>
              <button
                className="buttondeletearchive"
                onClick={() => removeFile(setDniUrl)}
              >
                <FaTrash />
              </button>
            </div>
          )}
          {formError && !dniurl && (
            <p className="errorMesage2">Por favor suba las imágenes pedidas</p>
          )}
        </div>

        <div className="boxbuttonpersonprev">
          <input
            type="file"
            ref={inputRefs.selfie}
            onChange={(event) => handleFileChange(event, setSelfieUrl)}
            style={{ display: "none" }}
          />
          <button
            className="boxinputprevarchive"
            onClick={() => inputRefs.selfie.current.click()}
          >
            <TbCloudUpload className="iconbuttonarchiveprev" />
            <span>Foto Selfie</span>
          </button>
          {selfieurl && (
            <div className="namefiledprov">
              <p className="buttonprevtextarchivedelete">{selfieurl.name}</p>
              <button
                className="buttondeletearchive"
                onClick={() => removeFile(setSelfieUrl)}
              >
                <FaTrash />
              </button>
            </div>
          )}
          {formError && !selfieurl && (
            <p className="errorMesage2">Por favor suba las imágenes pedidas</p>
          )}
        </div>
      </div>

      <div className="boxbuttonpersonprevlast">
        <input
          type="file"
          ref={inputRefs.sueldoname}
          onChange={(event) => handleFileChange(event, setSueldoName)}
          style={{ display: "none" }}
        />
        <button
          className="boxinputprevarchive"
          onClick={() => inputRefs.sueldoname.current.click()}
        >
          <TbCloudUpload className="iconbuttonarchiveprev" />
          <span>Recibo de Sueldo a su nombre</span>
        </button>
        {sueldoname && (
          <div className="namefiledprov">
            <p className="buttonprevtextarchivedelete">{sueldoname.name}</p>
            <button
              className="buttondeletearchive"
              onClick={() => removeFile(setSueldoName)}
            >
              <FaTrash />
            </button>
          </div>
        )}
        {formError && !sueldoname && (
          <p className="errorMesage2">Por favor suba las imágenes pedidas</p>
        )}
      </div>

      <div className="boxButtonarchive">
        <button onClick={ClickPageSix} className="Button4">
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default FormFive;
